export default __webpack_public_path__ + "images/RS.07270e1.png";